export const FeedbackStory = () => (
  <section className="border-b border-[color:var(--line)] bg-[#f1efe7]" data-testid="feedback-story-section">
    <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="sample-label-accent label !text-[10px]" data-testid="feedback-story-label">Why this exists</div>
        </div>
        <div className="md:col-span-8">
          <h2 className="font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="feedback-story-title">
            Three founders.<br /><span className="editorial font-normal">One promise.</span>
          </h2>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-8 text-[15px] leading-relaxed text-[color:var(--ink-2)] md:grid-cols-2 md:gap-14" data-testid="feedback-story-copy">
        <div className="space-y-7">
          <p>
            Vitura Labs™ was founded in 2025 by Andrew Hill, Dave Salvant and Verick Wayne on a simple premise: <strong className="font-semibold text-[color:var(--ink)]">performance shouldn’t cost you your health.</strong> Engineered for moving bodies and focused minds, Vitura combines clinically-backed nootropics, adaptogens and functional botanicals that work together, not against you—clean energy, sharp mental clarity, mood balance and stress resilience in a single daily shot.
          </p>
          <p>
            Most products give you energy. Some help you focus. A few claim to support mood. Almost none deliver all three without overstimulation, burnout or a crash.
          </p>
        </div>
        <div className="space-y-7">
          <p>
            The real innovation isn’t just what’s in the formula—it’s how we approach stimulation, mood and recovery. A clinically studied 28mg dose of saffron for real mood elevation. Paraxanthine, caffeine’s newer, cleaner metabolite, paired with matcha green tea and L-theanine for smooth, steady energy—sharp focus without the jitters or the crash. And clear-soluble curcumin, magnesium bisglycinate and vitamin C working alongside ashwagandha and rhodiola for stress resilience, inflammation support and recovery without fatigue.
          </p>
          <p>
            Vitura was built by three founders who’d each pushed themselves to the edge of what their bodies and minds could take, and came back determined to build the thing they wished they’d had.
          </p>
        </div>
      </div>

      <p className="mt-14 border-t border-[color:var(--line)] pt-8 font-display text-2xl leading-snug sm:text-3xl" data-testid="feedback-story-close">
        5 bottles. 5 mornings. Fuel five days of your best performance—<span className="editorial font-normal">at the gym, at work, and at home.</span>
      </p>
    </div>
  </section>
);